import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import { DashboardTabs } from "@/features/dashboard";
import { ClientReportList } from "@/features/reports";

export const Route = createFileRoute("/_authenticated/org/reports")({
  component: ClientReportsPage,
});

/**
 * The monthly reports The Motherhood writes for the org's leadership. View
 * and re-download only: The Motherhood owns what they say (SB-41).
 */
function ClientReportsPage() {
  return (
    <div>
      <PageHeader
        eyebrow="Your team"
        title="Dashboard"
        description="The monthly reports The Motherhood writes for your leadership."
      />
      <DashboardTabs />
      <ClientReportList />
    </div>
  );
}
